<template lang="pug">
  ul.applied-filters
    li(v-if="isCoachSupervisor && hasPatientFilters")
      button.tag.primary(@click="applyFilters()") Remove all filters
    li(v-if="patientFilters.coachingStatus")
      button.tag(@click="removeTag('coachingStatus')") {{ patientFilters.coachingStatus}}
    li(v-if="isCoachSupervisor && patientFilters.coachId")
      button.tag(@click="removeTag('coach')") {{ coachById(patientFilters.coachId) }}
    li(v-for="severity in patientFilters.severities")
      button.tag(@click="removeTag('severity', severity)") {{ severity }} Assessment Score
    li(v-if="patientFilters.assessmentTrend === 'improving'")
      button.tag(@click="removeTag('assessment')") Improving Functioning
    li(v-if="patientFilters.assessmentTrend === 'declining'")
      button.tag(@click="removeTag('assessment')") Declining Functioning
    li(v-if="patientFilters.moodTrend === 'improving'")
      button.tag(@click="removeTag('mood')") Improving Mood
    li(v-if="patientFilters.moodTrend === 'declining'")
      button.tag(@click="removeTag('mood')") Declining Mood
    li(v-for="focus in patientFilters.focuses")
      button.tag(@click="removeTag('focus', focus)")
        | {{ wellnessProgramByName(focus) }}
    li(v-for="ac in patientFilters.accessCodes")
      button.tag(@click="removeTag('ac', ac)") {{ ac }}
    li(v-for="ref in patientFilters.referrers")
      button.tag(@click="removeTag('referrer', ref)") {{ ref }}
    li(v-if="patientFilters.lastInteractionDays")
      button.tag(@click="removeTag('interaction')")
        | Interaction within {{ patientFilters.lastInteractionDays }} Days
    li(v-if="patientFilters.lastSupervisorReviewedDays")
      button.tag(@click="removeTag('lastSupervisorReviewedDays')")
        | Reviewed within {{ patientFilters.lastSupervisorReviewedDays }} Days
    li(v-if="patientFilters.reviewType == 'notReviewed'")
      button.tag(@click="removeTag('reviewed')") Not reviewed
    li(v-if="patientFilters.reviewType == 'reviewedWithin'")
      button.tag(@click="removeTag('reviewed')") No Review Within {{ patientFilters.lastReviewedDays }} Days
    li(v-if="patientFilters.patientEmail")
      button.tag(@click="removeTag('patientEmail')") Email {{ patientFilters.patientEmail }}
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PatientFilterTags',
  props: {
    hasPatientFilters: {
      type: Boolean,
      required: true
    },
    patientFilters: {
      required: false
    },
    applyFilters: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters(['coachById', 'wellnessProgramByName', 'isCoachSupervisor'])
  },
  methods: {
    removeTag(type, tag) {
      let update = {};
      switch (type) {
        case 'coachingStatus':
          update = { coachingStatus: null };
          break;
        case 'coach':
          update = { coachId: null };
          break;
        case 'severity':
          let list = this.patientFilters.severities.filter(
            item => item !== tag
          );
          update = { severities: list };
          break;
        case 'assessment':
          update = { assessmentTrend: null };
          break;
        case 'mood':
          update = { moodTrend: null };
          break;
        case 'focus':
          let fList = this.patientFilters.focuses.filter(item => item !== tag);
          update = { focuses: fList };
          break;
        case 'ac':
          let acList = this.patientFilters.accessCodes.filter(
            item => item !== tag
          );
          update = { accessCodes: acList };
          break;
        case 'referrer':
          let refList = this.patientFilters.referrers.filter(
            item => item !== tag
          );
          update = { referrers: refList };
          break;
        case 'interaction':
          update = { lastInteractionDays: null };
          break;
        case 'lastSupervisorReviewedDays':
          update = { lastSupervisorReviewedDays: null };
          break;
        case 'reviewed':
          update = { reviewType: null };
          break;
        case 'patientEmail':
          update = { patientEmail: null };
          break;
      }
      this.applyFilters(update);
    }
  }
};
</script>

<style lang="scss" scoped>
.applied-filters {
  margin: $small-spacing auto $xs-spacing;
  padding: 0;
  min-height: 2em;
  li {
    display: inline-block;
    margin-right: 4px;
    margin-bottom: 6px;
  }
  button.tag {
    position: relative;
    padding: 4px 8px;
    padding-left: 24px;
    border-radius: 1em;
    font-family: $sans-font-family;
    font-size: $ms-down1;
    text-transform: uppercase;
    color: $grey;
    cursor: hand;
    background-image: linear-gradient(to bottom, #fff 70%, $md-grey-100);
    border: 1px solid $md-grey-200;
    transition: all 0.25s ease;
    &:before {
      content: '\2716';
      display: block;
      position: absolute;
      left: 6px;
      top: 6px;
      color: $error-color !important;
      font-size: $ms-down1;
    }
    &:hover,
    &:focus {
      border-color: $action-color;
      color: $action-color;
      background: #fff;
      @include drop-shadow;
      outline: none;
    }
    &:active {
      outline: none;
      opacity: 0.6;
      margin-top: 1px;
      box-shadow: 0 0 0 rgba(#fff, 0);
      transform: scale(0.98);
    }
    &.primary {
      color: $action-color;
      font-weight: $base-font-weight-strong;
    }
  }
}
</style>
